import { useTranslation } from 'react-i18next';
import { useListRecordsQuery } from '@platform/state/api';
import { recordCode } from '../../form/header/recordCode';
import type { ILawHeaderProps } from './ILawHeaderProps';
import { normCounts } from './lawArticles';
import { normTone } from './lawTones';

/**
 * Шапка візуальної моделі закону (прототип v4 vizLaw): «Законопроєкт для перегляду» — перелік законопроєктів робочого простору
 * («101 · Назва»; вибір відкриває інший законопроєкт на тій самій вкладці); підсумок «Статей: N · впливів: N · відкритих колізій: N ·
 * пов'язаних актів: N» і пігулки типів норм «Право · 1» у кольорі норми.
 */
export function LawHeader({ ws, rtKey, draft, law, arts, labels, onDraft }: ILawHeaderProps) {
  const { t } = useTranslation();
  const { data } = useListRecordsQuery({ ws, rt: rtKey, params: { pageSize: 100, sort: 'code', facets: false } });
  const drafts = data?.items.some((d) => d.id === draft.id) ? data.items : [draft, ...(data?.items ?? [])];
  const stats = {
    arts: arts.length, imps: law.of('ldimp').length, conf: law.of('ldconf').filter((r) => r.status !== 'Resolved').length,
    links: law.of('ldlink').filter((r) => r.status !== 'Archived').length,
  };
  return (
    <>
      <label className="law__draft">
        <span className="law__draft-label">{t('recordPage.law.draft')}</span>
        <select className="law__select" value={draft.id} aria-label={t('recordPage.law.draft')} onChange={(e) => onDraft(e.target.value)}>
          {drafts.map((d) => <option key={d.id} value={d.id}>{`${recordCode(d.display, d.code)} · ${d.title || t('recordPage.law.untitled')}`}</option>)}
        </select>
      </label>
      <div className="law__stats">
        <span className="law__stats-text">{t('recordPage.law.stats', stats)}</span>
        <div className="law__norms">
          {normCounts(arts).map((g) => (
            <span key={g.value} className={`law__norm law-t-${normTone(g.value)}`}>
              <span>{labels.option('ldart', 'norm', g.value)}</span>{' · '}<span>{g.items.length}</span>
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
